var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportClearanceGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_9290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_9290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_9290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_472_9290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_472_9290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2907 25.6648H6.70956C5.58978 25.6648 4.66824 24.7433 4.66824 23.6234V4.37652C4.66824 3.25674 5.58978 2.33521 6.70956 2.33521H21.2907C22.4105 2.33521 23.332 3.25674 23.332 4.37652V23.6235C23.332 24.7433 22.4105 25.6649 21.2907 25.6649M6.70956 4.08492C6.54626 4.08492 6.41796 4.21322 6.41796 4.37652V23.6235C6.41796 23.7868 6.54626 23.9151 6.70956 23.9151H21.2907C21.454 23.9151 21.5823 23.7868 21.5823 23.6235V4.37652C21.5823 4.21322 21.454 4.08492 21.2907 4.08492H6.70956Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7202 12.262H9.04262C8.56438 12.262 8.16774 11.8654 8.16774 11.3872V6.7096C8.16774 6.23136 8.56433 5.83472 9.04262 5.83472H13.7202C14.1984 5.83472 14.595 6.23131 14.595 6.7096V11.3872C14.595 11.8654 14.1984 12.262 13.7202 12.262ZM9.91746 10.5123H12.8453V7.58444H9.91746V10.5123ZM18.9577 15.7498H9.04251C8.56427 15.7498 8.16768 15.3532 8.16768 14.8749C8.16768 14.3967 8.56427 14.0001 9.04251 14.0001H18.9577C19.4359 14.0001 19.8326 14.3967 19.8326 14.8749C19.8326 15.3531 19.436 15.7498 18.9577 15.7498ZM18.9577 18.9693H9.04251C8.56427 18.9693 8.16768 18.5726 8.16768 18.0944C8.16768 17.6162 8.56427 17.2196 9.04251 17.2196H18.9577C19.4359 17.2196 19.8326 17.6162 19.8326 18.0944C19.8326 18.5726 19.436 18.9693 18.9577 18.9693ZM13.7085 22.1654H9.04257C8.56433 22.1654 8.16774 21.7688 8.16774 21.2905C8.16774 20.8123 8.56433 20.4157 9.04257 20.4157H13.7085C14.1867 20.4157 14.5834 20.8123 14.5834 21.2905C14.5834 21.7688 14.1868 22.1654 13.7085 22.1654Z",
    fill: "#E2E2E2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_9290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportClearanceGrey);
export default __webpack_public_path__ + "static/media/exportClearanceGrey.b9cf3ffaddb733dba4ce5a46566ae126.svg";
export { ForwardRef as ReactComponent };